/**
 * French translations
 */

export default {
  GitHub: 'GitHub',
  'Trending repos': 'Dépôts populaires',
  'Copilot for business': 'Copilot for Business',
  'Resource center': 'Centre de ressources',
  'Enterprise-grade code security': 'Sécurité du code de niveau entreprise',
  'Your source for the latest features, improvements, and fixes across GitHub products, all in one place.':
    'Les dernières fonctionnalités, améliorations et corrections des produits GitHub, réunies au même endroit.',
  'The event for developers, by developers — talks, workshops, and what’s next for GitHub.':
    'L’événement pour les développeurs, par les développeurs : conférences, ateliers et prochaines nouveautés GitHub.',
  'Repository hosting, code review, and collaboration': 'Hébergement de dépôts, revue de code et collaboration',
  'Build & Ship': 'Développer et livrer',
  'CI/CD and automation': 'CI/CD et automatisation',
  'Quality analysis, fixes, and enforcement': 'Analyse de la qualité, corrections et application des normes',
  Code: 'Coder',
  'AI coding agent for tasks, projects and automated work':
    'Agent de programmation IA pour les tâches, les projets et le travail automatisé',
  'Cloud development environments': 'Environnements de développement cloud',
  Secure: 'Sécuriser',
  'Vulnerability detection and remediation': 'Détection et correction des vulnérabilités',
  'Secret scanning and leak prevention': 'Analyse des secrets et prévention des fuites',
  Learn: 'Apprendre',
  Certifications: 'Certifications',
  Build: 'Développer',
  'Customize Copilot': 'Personnaliser Copilot',
  Explore: 'Explorer',
  'Trending Repos': 'Dépôts populaires',
  Events: 'Événements',
  Businesses: 'Entreprises',
  'By Stage': 'Par stade de développement',
  'Small & medium teams': 'Petites et moyennes équipes',
  'By Industry': 'Par secteur d’activité',
  'See all industries': 'Voir tous les secteurs',
  'Evaluate GitHub': 'Évaluer GitHub',
  'Add-ons': 'Modules complémentaires',
  'Learn & Connect': 'Apprendre et échanger',
  'Resource Center': 'Centre de ressources',
  'Customer Support': 'Support client',
  'About GitHub': 'À propos de GitHub',
  'Enter your email': 'Entrez votre adresse e-mail',
  'Not included': 'Non inclus',
  'Pause video': 'Mettre la vidéo en pause',
  'Play video': 'Lire la vidéo',
  'Pricing plans': 'Plans tarifaires',
  'Select an option': 'Sélectionnez une option',
  'Sign up for GitHub': 'Inscrivez-vous à GitHub',
  Country: 'Pays',
  'The following fields have errors:': 'Les champs suivants contiennent des erreurs :',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    'Vous avez le droit de refuser la collecte et l’utilisation de vos informations personnelles, l’utilisation de vos informations personnelles à des fins marketing et la réception d’informations marketing comme indiqué ci-dessus. Toutefois, si vous refusez, vous pourriez ne pas être en mesure de bénéficier des avantages décrits dans la section Objet de la collecte et de l’utilisation.',
  'I agree to the collection and use of my personal information (required)*.':
    'J’accepte la collecte et l’utilisation de mes informations personnelles (obligatoire)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    'Éléments d’informations personnelles à collecter : {fields}, et tout autre champ visible sur ce formulaire.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    'Objet de la collecte et de l’utilisation : GitHub utilisera les données aux fins décrites dans ce formulaire.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    'Période de conservation/utilisation des informations personnelles : aussi longtemps que nécessaire pour fournir le(s) service(s) que vous demandez.',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'J’accepte de recevoir des informations marketing et l’utilisation de mes informations personnelles à des fins marketing (facultatif).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'Consentement à recevoir des communications marketing : les informations collectées peuvent être utilisées par GitHub pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    'Objet de la collecte et de l’utilisation : vous contacter à des fins marketing.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    'Période de conservation/utilisation des informations personnelles : aussi longtemps que nécessaire pour fournir le(s) service(s) que vous demandez.',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'Oui, je souhaite que GitHub et ses sociétés affiliées utilisent mes informations pour obtenir des communications personnalisées, de la publicité ciblée et des campagnes plus efficaces. Consultez la',
  'for more details.': 'pour plus de détails.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    'La participation nécessite le transfert de vos données personnelles vers d’autres pays dans lesquels GitHub opère, y compris les États-Unis. En soumettant ce formulaire, vous acceptez le transfert de vos données en dehors de la Chine.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    'Je recevrai des communications personnalisées et de la publicité ciblée de la part de GitHub et de ses sociétés affiliées. Consultez la',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Oui, je souhaite recevoir des informations de GitHub et de son groupe d’entreprises par e-mail pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes. Pour retirer votre consentement ou gérer vos préférences de contact, visitez le',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Oui, je souhaite recevoir des informations de GitHub et de son groupe d’entreprises par e-mail et téléphone pour des communications personnalisées, de la publicité ciblée et l’efficacité des campagnes. Pour retirer votre consentement ou gérer vos préférences de contact, visitez le',
  'Promotional Communications Manager': 'Gestionnaire de communications promotionnelles',
  'GitHub Privacy Statement': 'Déclaration de confidentialité de GitHub',
  '(Updated 02/2024)': '(Mise à jour 02/2024)',
  'first name': 'prénom',
  'last name': 'nom',
  company: 'entreprise',
  email: 'e-mail',
  'This field is required.': 'Ce champ est obligatoire.',
  'Please enter a valid value.': 'Veuillez entrer une valeur valide.',
  'Please enter a valid work email address.': 'Veuillez entrer une adresse e-mail professionnelle valide.',
  'The email is from a personal email provider.':
    'L’adresse e-mail provient d’un fournisseur de messagerie personnelle.',
  'Please enter a valid email address.': 'Veuillez entrer une adresse e-mail valide.',
  'Please enter a valid phone number.': 'Veuillez entrer un numéro de téléphone valide.',
  'Please select your country/region': 'Veuillez sélectionner votre pays/région.',
  'Please complete the CAPTCHA.': 'Veuillez compléter le CAPTCHA.',
  'Choose your country/region': 'Choisissez votre pays/région.',
  Included: 'Inclus',
  Refresh: 'Actualiser',
  Unlimited: 'Illimité',
  'Learn more': 'En savoir plus',
  'Dev Days are here! Join an in-person event near you to learn more about the GitHub Copilot app and Copilot CLI with your community.':
    'Les Dev Days sont arrivés ! Inscrivez-vous pour animer près de chez vous un événement en personne de présentation de l’application GitHub Copilot et de la CLI Copilot.',
  'Sort by:': 'Trier par :',
  'Selecting a sort option will reload the page.': 'La sélection d’une option de tri rechargera la page.',
  'Sort options': 'Options de tri',
  Sort: 'Trier',
  Newest: 'Plus récent',
  Oldest: 'Plus ancien',
  Whitepaper: 'Livre blanc',
  'Content Type': 'Type de contenu',
  Category: 'Catégorie',
  Whitepapers: 'Livres blancs',
  Ebooks: 'Livres numériques',
  AI: 'IA',
  Cloud: 'Cloud',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'Innersource',
  'Open Source': 'Open Source',
  Security: 'Sécurité',
  'Software Development': 'Développement logiciel',
  'Explore other resources': 'Découvrez d’autres ressources',
  Share: 'Partager',
  'Ebooks & Whitepapers': 'Livres numériques et livres blancs',
  Tags: 'Tags',
  Ebook: 'Livre numérique',
  Platform: 'Plateforme',
  'AI CODE CREATION': 'CRÉATION DE CODE PAR IA',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'Améliorez votre code avec l’IA',
  'GitHub Copilot app': 'Application GitHub Copilot',
  'Direct agents from issue to merge': 'Dirigez les agents de l’issue au merge',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'Créez et déployez des applications intelligentes',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'Gérez et comparez les prompts',
  'MCP Registry (New)': 'MCP Registry (Nouveau)',
  'Integrate external tools': 'Intégrez des outils externes',
  'View all features': 'Voir toutes les fonctionnalités',
  'DEVELOPER WORKFLOWS': 'WORKFLOWS DE DÉVELOPPEMENT',
  Actions: 'Actions',
  'Automate any workflow': 'Automatisez n’importe quel workflow',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'Environnements de développement instantanés',
  Issues: 'Issues',
  'Plan and track work': 'Planifiez et suivez le travail',
  'Code review': 'Revue de code',
  'Manage code changes': 'Gérez les modifications de code',
  'APPLICATION SECURITY': 'SÉCURITÉ DES APPLICATIONS',
  'Find and fix vulnerabilities': 'Détectez et corrigez les vulnérabilités',
  'Code Security': 'GitHub Code Security',
  'Secure your code as you build': 'Sécurisez votre code dès sa création',
  'Secret Protection': 'GitHub Secret Protection',
  'Stop leaks before they start': 'Empêchez les fuites avant qu’elles ne surviennent',
  EXPLORE: 'EXPLORER',
  'Why GitHub': 'Pourquoi GitHub ?',
  Documentation: 'Documentation',
  Blog: 'Blog',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'Solutions',
  'BY COMPANY SIZE': 'PAR TAILLE D’ENTREPRISE',
  Enterprises: 'Entreprise',
  'Small and medium teams': 'Petites et moyennes équipes',
  Startups: 'Start-ups',
  Nonprofits: 'Organisations à but non lucratif',
  'View all solutions': 'Voir toutes les solutions',
  'BY USE CASE': 'PAR CAS D’UTILISATION',
  'App modernization': 'Modernisation des applications',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'Voir tous les cas d’utilisation',
  'BY INDUSTRY': 'PAR SECTEUR D’ACTIVITÉ',
  Healthcare: 'Santé',
  'Financial services': 'Services financiers',
  Manufacturing: 'Industrie manufacturière',
  Government: 'Secteur public',
  'View all industries': 'Voir tous les secteurs',
  Resources: 'Ressources',
  'EXPLORE BY TOPIC': 'EXPLORER PAR THÈME',
  'Software development': 'Développement logiciel',
  'View all topics': 'Voir tous les thèmes',
  'EXPLORE BY TYPE': 'EXPLORER PAR TYPE',
  'Customer stories': 'Témoignages de notre clientèle',
  'Events & webinars': 'Événements et webinaires',
  'Ebooks & reports': 'Ebooks et rapports',
  'Business insights': 'Insights stratégiques',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'ASSISTANCE ET SERVICES',
  Customer: 'Assistance client',
  'Customer support': 'Support client',
  'Community forum': 'Forum de la communauté',
  'Trust Center': 'Trust Center',
  Partners: 'Partenaires',
  COMMUNITY: 'COMMUNAUTÉ',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'Soutenez le développement open source',
  'The ReadME Project': 'The ReadME Project',
  'GitHub community articles': 'Articles de la communauté GitHub',
  'COMMUNITY PROGRAMS': 'PROGRAMMES COMMUNAUTAIRES',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'Communauté des mainteneurs',
  Accelerator: 'Accélérateur',
  'Archive Program': 'Archivage de programme',
  REPOSITORIES: 'RÉFÉRENTIELS',
  Topics: 'Thèmes',
  Trending: 'Tendances',
  Collections: 'Collections',
  Enterprise: 'Entreprise',
  'ENTERPRISE SOLUTIONS': 'SOLUTIONS POUR ENTREPRISES',
  'Enterprise platform': 'Plateforme GitHub Enterprise',
  'AI-powered developer platform': 'Plateforme de développement alimentée par l’IA',
  'AVAILABLE ADD-ONS': 'EXTENSIONS DISPONIBLES',
  'Enterprise-grade application security': 'Sécurité des applications niveau entreprise',
  'Copilot for Business': 'Copilot for Business',
  'Enterprise-grade AI features': 'Fonctionnalités IA de niveau entreprise',
  'Premium Support': 'Support Premium',
  'Enterprise-grade 24/7 support': 'Support 24/7 de niveau entreprise',
  New: 'Nouveau',
  Select: 'Sélectionner',
  'Install with script': 'Installer avec un script',
  'Install with npm': 'Installer avec npm',
  'Install with Homebrew': 'Installer avec Homebrew',
  'Install with WinGet': 'Installer avec WinGet',
  Copy: 'Copier',
  'Copy installation command': 'Copier la commande d’installation',
  'Copied to clipboard': 'Copié dans le presse-papiers',
  'Send me a download link': 'M’envoyer un lien de téléchargement',
  'Download link copied.': 'Lien de téléchargement copié.',
  Copied: 'Copié',
  'Copy download link': 'Copier le lien de téléchargement',
  "This browser doesn't support sharing. Copy the download link instead.":
    'Ce navigateur ne prend pas en charge le partage. Copiez plutôt le lien de téléchargement.',
  "We couldn't share the download link. Copy it instead.":
    'Impossible de partager le lien de téléchargement. Copiez-le à la place.',
  "This browser doesn't support copying. Copy the current page URL from the address bar instead.":
    'Ce navigateur ne prend pas en charge la copie. Copiez plutôt l’URL de la page actuelle depuis la barre d’adresse.',
  "We couldn't copy the download link. Copy the current page URL from the address bar instead.":
    'Impossible de copier le lien de téléchargement. Copiez plutôt l’URL de la page actuelle depuis la barre d’adresse.',
  'The download link is invalid. Please try again later.':
    'Le lien de téléchargement n’est pas valide. Veuillez réessayer plus tard.',
  "We couldn't copy the download link. Copy the link below instead.":
    'Impossible de copier le lien de téléchargement. Copiez plutôt le lien ci-dessous.',
  "This browser doesn't support copying. Copy the link below instead.":
    'Ce navigateur ne prend pas en charge la copie. Copiez plutôt le lien ci-dessous.',
  'Select install method': 'Sélectionnez la méthode d’installation',
  'Get Copilot CLI': 'Obtenir Copilot CLI',
  'Read the documentation.': 'Consultez la documentation.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Inclus dans les abonnements Copilot Free, Pro, Pro+, Business et Enterprise.',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'Inclus dans les abonnements Copilot Free, Pro, Pro+, Max, Business et Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Disponible avec Copilot Free, Pro, Pro+, Business et Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'Disponible avec Copilot Free, Pro, Pro+, Max, Business et Enterprise.',
  'View all resources': 'Voir toutes les ressources',
  'Enterprise-grade security features': 'Fonctionnalités de sécurité de niveau entreprise',
  Pricing: 'Tarifs',
  'Select country for phone number. Currently selected:':
    'Sélectionner le pays pour le numéro de téléphone. Sélection actuelle :',
  'Search countries': 'Rechercher des pays',
  'Search countries...': 'Rechercher des pays...',
  Countries: 'Pays',
  'No countries found': 'Aucun pays trouvé',
  '{count} result available': '{count} résultat disponible',
  '{count} results available': '{count} résultats disponibles',
  'Get the ebook': 'Télécharger l’Ebook',
  'Get the analysis': 'Télécharger l’analyse',

  // Marketing navigation and footer
  Products: 'Produits',
  Copilot: 'Copilot',
  'All Features': 'Toutes les fonctionnalités',
  Developers: 'Développeurs et développeuses',
  'GitHub CLI': 'GitHub CLI',
  'GitHub Desktop': 'GitHub Desktop',
  'GitHub Mobile': 'GitHub Mobile',
  Integrations: 'Intégrations',
  'MCP Registry': 'Registre MCP',
  Training: 'Formation',
  'Build with Copilot': 'Créer avec Copilot',
  'GitHub Status': 'GitHub Status',

  // Marketing footer
  Subscribe: 'S’abonner',
  Ecosystem: 'Écosystème',
  Support: 'Aide',
  Company: 'Entreprise',
  Features: 'Fonctionnalités',
  Team: 'Équipe',
  Roadmap: 'Roadmap',
  'Compare GitHub': 'Comparaison GitHub',
  'Developer API': 'API pour les devs',
  Education: 'Éducation',
  Docs: 'Documentation',
  'Community Forum': 'Forum de la communauté',
  'Professional Services': 'Services professionnels',
  Skills: 'Compétences',
  Status: 'Statut',
  'Contact GitHub': 'Contacter GitHub',
  About: 'À propos',
  Careers: 'Carrières',
  Newsroom: 'Salle de rédaction',
  Inclusion: 'Inclusion',
  'Social Impact': 'Social Impact',
  Shop: 'Boutique',
  'What is Git?': 'Qu’est-ce que Git\u00a0?',
  Sitemap: 'Plan du site',
  Terms: 'Conditions d’utilisation',
  Privacy: 'Confidentialité',
  'Manage cookies': 'Gestion des cookies',
  'Do not share my personal information': 'Ne pas partager mes informations personnelles',

  // Marketing footer — newsletter heading/description reuse legacy copy (pending loc review)
  'The developer newsletter': 'Abonnez-vous à notre bulletin d’informations pour les développeurs',
  'Get tips, technical guides, and best practices. Twice a month. Right in your inbox.':
    'Obtenez des conseils, des guides techniques et des meilleures pratiques. Deux fois par mois. Directement dans votre boîte de réception.',
  'Customer Stories': 'Témoignages de notre clientèle',

  // Marketing footer — a11y/nav and social labels (drafted, pending loc verification)
  'Go to GitHub homepage': 'Aller à la page d’accueil de GitHub',
  'Site-wide Links': 'Liens à l’échelle du site',
  'Legal and Resource Links': 'Liens juridiques et ressources',
  "GitHub's Social Media Links": 'Liens des réseaux sociaux de GitHub',
  'Select language': 'Sélectionner la langue',
  'GitHub on LinkedIn': 'GitHub sur LinkedIn',
  'GitHub on Instagram': 'GitHub sur Instagram',
  'GitHub on YouTube': 'GitHub sur YouTube',
  'GitHub on X': 'GitHub sur X',
  'GitHub on TikTok': 'GitHub sur TikTok',
  'GitHub on Twitch': 'GitHub sur Twitch',
  'GitHub’s organization on GitHub': 'L’organisation GitHub sur GitHub',

  // Article page table of contents
  'Table of contents': 'Sommaire',
  'Open table of contents': 'Ouvrir le sommaire',
  'Close table of contents': 'Fermer le sommaire',
  'Code Quality': 'Code Quality',
  'Enforce quality at merge': 'Garantissez la qualité au moment du merge',
  // EmailCaptureForm
  'Email address': 'Adresse e-mail',
  'Email capture form': 'Formulaire de collecte d’adresse e-mail',
  'Submitting your email address…': 'Envoi de votre adresse e-mail…',
  'Thanks! Your email address has been submitted.': 'Merci ! Votre adresse e-mail a bien été envoyée.',
  'Something went wrong. Please try again.': 'Une erreur s’est produite. Veuillez réessayer.',
  'More information about {feature}': 'Plus d’informations sur {feature}',
  'More information about this feature': 'Plus d’informations sur cette fonctionnalité',
  // Add more translations here
}
